export function getDistanceToBoundingBox(schemeElement: HTMLDivElement, itemsLength: number, isReversed: boolean) {
  const height = schemeElement.querySelector('.circled-dotted-scheme')?.clientHeight || 0;

  let distanceInPercentOfSchemeCircle: number;

  if (isReversed) {
    distanceInPercentOfSchemeCircle = distancesToBoundingBoxReversed.get(itemsLength) || 0;
  } else {
    distanceInPercentOfSchemeCircle = distancesToBoundingBox.get(itemsLength) || 0;
  }

  return (height * distanceInPercentOfSchemeCircle) / 100;
}

// the first number is the number of dots, the second - distanceToBoundingBox in percents of
// .circled-dotted-scheme element (circle)

const distancesToBoundingBox = new Map<number, number>([
  [5, 11.2],
  [7, 6.3],
  [9, 3],
  [11, 1.75],
]);
const distancesToBoundingBoxReversed = new Map<number, number>([
  [5, 11.2],
  [6, 9],
  [7, 6.3],
  [8, 3.5],
  [9, 3],
  [10, 1.75],
  [11, 1.75],
  [12, 1.75],
]);
const dotRadiusPx = 5;

// Functions to calculate paddings of the scheme-container

export function calculatePaddingTop(schemeElement: HTMLDivElement, itemsLength: number, isReversed: boolean): number {
  if (!isReversed) {
    const upperElementHeight = schemeElement.querySelector('.circled-dotted-scheme-item-0')?.clientHeight;

    return upperElementHeight ? upperElementHeight - dotRadiusPx : 0;
  }

  const firstUpperElementHeight = schemeElement.querySelector('.circled-dotted-scheme-item-0')?.clientHeight;
  const lastUpperElementHeight = schemeElement.querySelector(
    `.circled-dotted-scheme-item-${itemsLength - 1}`,
  )?.clientHeight;

  if (firstUpperElementHeight !== undefined && lastUpperElementHeight !== undefined) {
    return (
      Math.max(firstUpperElementHeight, lastUpperElementHeight) -
      getDistanceToBoundingBox(schemeElement, itemsLength, isReversed) -
      dotRadiusPx
    );
  }

  return 0;
}

export function calculatePaddingBottom(
  schemeElement: HTMLDivElement,
  itemsLength: number,
  isReversed: boolean,
): number {
  if ((isReversed && itemsLength % 2 === 0) || (!isReversed && itemsLength % 2 !== 0)) {
    const firstLowerElementHeight = schemeElement.querySelector(
      `.circled-dotted-scheme-item-${Math.floor((itemsLength - 1) / 2)}`,
    )?.clientHeight;
    const lastLowerElementHeight = schemeElement.querySelector(
      `.circled-dotted-scheme-item-${Math.floor((itemsLength - 1) / 2) + 1}`,
    )?.clientHeight;

    if (firstLowerElementHeight !== undefined && lastLowerElementHeight !== undefined) {
      return (
        Math.max(firstLowerElementHeight, lastLowerElementHeight) -
        getDistanceToBoundingBox(schemeElement, itemsLength, isReversed) -
        dotRadiusPx
      );
    }
  }

  const lowerElementHeight = schemeElement.querySelector(
    `.circled-dotted-scheme-item-${Math.floor(itemsLength / 2)}`,
  )?.clientHeight;

  return lowerElementHeight ? lowerElementHeight - dotRadiusPx : 0;
}
